import React from 'react'
import { Link } from 'react-static'
import VisibilitySensor from 'react-visibility-sensor'

class Stats extends React.Component {
  constructor(props) {
    super(props)
    this.state = {visible: false}
  }

  animateBar = (isActive) => {
    this.setState({active: isActive});
  }

  createBars = (bars) => {
    const barMarkup = bars.map((bar, index) => {
      let barFill = parseFloat((bar.value / bar.max)*100).toFixed(3)

      return (
        <div key={index} className="stat__bar__inner" style={{ width: `${barFill}%` }}></div>
      )
    })

    return barMarkup
  }

  createStats = (stats) => {
    const statMarkup = stats.map((stat, index) => {
      return (
        <div key={index} className="stat">
          <div className="stat__bar">
            {this.createBars(stat.bars)}
          </div>
          <div className="stat__labels">
            <div className="stat__labels-left">{stat.label_left}</div>
            <div className="stat__labels-right">{stat.label_right}</div>
          </div>
        </div>
      )})

    return statMarkup
  }

  render() {
    return (
      <VisibilitySensor onChange={this.animateBar} active={!this.state.active}>
        { ({isVisible} ) =>
          <div className={isVisible ? 'stats-container is-visible' : 'stats-container not-visible'}>
            {this.createStats(this.props.stats)}
          </div>
        }
      </VisibilitySensor>
    )
  }
}

export default Stats;



// WEBPACK FOOTER //
// /Users/terrymasher/Development/glenbeigh-ltd/src/components/Stats.js